export interface Movie {
  id: number;
  title: string;
  subtitle: string;
  year: number;
  category: string;
  rating: number;
  duration: string;
  description: string;
  image: string;
  tags: string[];
  isNew: boolean;
  isHot: boolean;
  isRecommended: boolean;
  region: string;
  director: string;
  cast: string[];
}

export const movies: Movie[] = [
  {
    id: 1,
    title: '烈火战将',
    subtitle: 'Blazing Warrior',
    year: 2026,
    category: 'dongzuo',
    rating: 8.7,
    duration: '128分钟',
    description: '退役特种兵陈烈在目睹黑帮横行乡里后，毅然挺身而出。一场惊心动魄的正邪较量在繁华都市的暗处展开，拳拳到肉的打斗场面令人热血沸腾。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20action%20movie%20poster%20with%20a%20fierce%20warrior%20in%20combat%20pose%2C%20dark%20urban%20background%20with%20fire%20and%20explosions%2C%20cinematic%20lighting%2C%20intense%20expression%2C%20movie%20poster%20style%20with%20Chinese%20typography%20vibe%2C%20warm%20toned%20color%20grading%2C%20dramatic%20composition&width=800&height=1120&seq=movie-001&orientation=portrait',
    tags: ['硬汉', '枪战', '热血'],
    isNew: false,
    isHot: true,
    isRecommended: true,
    region: '中国大陆',
    director: '林超贤',
    cast: ['吴京', '张译', '李晨'],
  },
  {
    id: 2,
    title: '星际迷途：重生',
    subtitle: 'Star Trek: Rebirth',
    year: 2026,
    category: 'kehuan',
    rating: 9.1,
    duration: '156分钟',
    description: '公元2157年，人类首个深空探索飞船"曙光号"在执行任务时遭遇未知信号。船员们发现了一个足以改变人类命运的惊天秘密。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20poster%20with%20astronaut%20floating%20in%20deep%20space%2C%20nebula%20and%20stars%20background%2C%20futuristic%20spaceship%20in%20distance%2C%20cinematic%20atmosphere%2C%20cool%20tone%20with%20warm%20accents%2C%20movie%20poster%20aesthetic&width=800&height=1120&seq=movie-002&orientation=portrait',
    tags: ['太空', '冒险', '特效'],
    isNew: true,
    isHot: true,
    isRecommended: true,
    region: '中国大陆',
    director: '郭帆',
    cast: ['刘德华', '吴京', '赵今麦'],
  },
  {
    id: 3,
    title: '笑傲江湖之风云再起',
    subtitle: 'Swordsman Reborn',
    year: 2026,
    category: 'dongzuo',
    rating: 8.5,
    duration: '135分钟',
    description: '令狐冲在江湖纷争中再度出山，面对新的敌人和旧的情感纠葛，他将如何抉择？经典武侠的全新演绎，刀光剑影中的侠义柔情。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20wuxia%20movie%20poster%20with%20swordsman%20in%20flowing%20robes%20on%20mountain%20peak%2C%20misty%20landscape%20with%20pine%20trees%2C%20dramatic%20sky%2C%20elegant%20composition%2C%20warm%20earth%20tones%2C%20traditional%20Chinese%20painting%20aesthetic&width=800&height=1120&seq=movie-003&orientation=portrait',
    tags: ['武侠', '江湖', '经典'],
    isNew: true,
    isHot: false,
    isRecommended: true,
    region: '中国香港',
    director: '徐克',
    cast: ['肖战', '杨紫', '成龙'],
  },
  {
    id: 4,
    title: '爆笑家族',
    subtitle: 'Funny Family',
    year: 2026,
    category: 'xiju',
    rating: 8.3,
    duration: '118分钟',
    description: '三代同堂的大家庭里，每个人都有自己的烦恼和秘密。当一场意外的婚礼将所有人聚在一起时，笑料百出的故事就此展开。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20movie%20poster%20with%20a%20large%20family%20gathering%20at%20dinner%20table%2C%20chaotic%20and%20funny%20expressions%2C%20warm%20home%20interior%2C%20bright%20lighting%2C%20joyful%20atmosphere%2C%20colorful%20and%20vibrant&width=800&height=1120&seq=movie-004&orientation=portrait',
    tags: ['家庭', '搞笑', '温情'],
    isNew: false,
    isHot: true,
    isRecommended: false,
    region: '中国大陆',
    director: '贾玲',
    cast: ['沈腾', '马丽', '贾玲'],
  },
  {
    id: 5,
    title: '初恋这件大事',
    subtitle: 'First Love Matters',
    year: 2026,
    category: 'aiqing',
    rating: 8.0,
    duration: '110分钟',
    description: '高中时期的懵懂初恋，十年后的重逢。当青春的记忆涌上心头，他们能否跨越现实的鸿沟，再次找到彼此？',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20romance%20movie%20poster%20with%20young%20couple%20under%20cherry%20blossom%20trees%2C%20soft%20sunlight%2C%20pastel%20pink%20and%20warm%20tones%2C%20dreamy%20atmosphere%2C%20school%20uniform%2C%20romantic%20cinematic%20feel&width=800&height=1120&seq=movie-005&orientation=portrait',
    tags: ['青春', '校园', '治愈'],
    isNew: false,
    isHot: false,
    isRecommended: true,
    region: '中国大陆',
    director: '陈思诚',
    cast: ['刘浩存', '易烊千玺', '周也'],
  },
  {
    id: 6,
    title: '暗夜追踪',
    subtitle: 'Night Pursuit',
    year: 2026,
    category: 'xuanyi',
    rating: 8.9,
    duration: '142分钟',
    description: '一名调查记者在追踪一桩陈年悬案时，意外发现自己被卷入了一个巨大的阴谋之中。真相与谎言交织，步步惊心。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20suspense%20thriller%20movie%20poster%20with%20detective%20in%20rainy%20alley%20at%20night%2C%20neon%20lights%20reflection%2C%20mysterious%20silhouette%2C%20dark%20moody%20atmosphere%2C%20film%20noir%20style%2C%20cool%20blue%20and%20red%20contrast&width=800&height=1120&seq=movie-006&orientation=portrait',
    tags: ['悬疑', '犯罪', '烧脑'],
    isNew: true,
    isHot: true,
    isRecommended: true,
    region: '中国大陆',
    director: '曹保平',
    cast: ['张译', '王传君', '谭卓'],
  },
  {
    id: 7,
    title: '幽灵古宅',
    subtitle: 'The Haunted Mansion',
    year: 2026,
    category: 'kongbu',
    rating: 7.8,
    duration: '105分钟',
    description: '一群探险者在深山中发现了一座废弃的古宅。当夜幕降临，诡异的事件接连发生，他们发现这座宅子里隐藏着不为人知的恐怖秘密。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20horror%20movie%20poster%20with%20haunted%20traditional%20Chinese%20mansion%20in%20dark%20forest%2C%20ghostly%20figure%20in%20window%2C%20moonlight%2C%20eerie%20atmosphere%2C%20fog%2C%20cold%20green%20and%20black%20tones&width=800&height=1120&seq=movie-007&orientation=portrait',
    tags: ['惊悚', '灵异', '冒险'],
    isNew: false,
    isHot: false,
    isRecommended: false,
    region: '中国大陆',
    director: '温子仁',
    cast: ['朱一龙', '倪妮', '文咏珊'],
  },
  {
    id: 8,
    title: '海底总动员：新冒险',
    subtitle: 'Finding Ocean 3',
    year: 2026,
    category: 'donghua',
    rating: 8.6,
    duration: '98分钟',
    description: '小鱼尼莫和朋友们踏上了一段全新的海洋冒险。色彩斑斓的海底世界，惊险刺激的旅程，适合全家观看的温馨故事。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20movie%20poster%20with%20colorful%20tropical%20fish%20in%20coral%20reef%20ocean%2C%20bright%20sunlight%20rays%20through%20water%2C%20playful%20expressions%2C%20vibrant%20colors%2C%20family-friendly%20atmosphere%2C%20whimsical%20style&width=800&height=1120&seq=movie-008&orientation=portrait',
    tags: ['动画', '冒险', '家庭'],
    isNew: false,
    isHot: false,
    isRecommended: true,
    region: '中国大陆',
    director: '田晓鹏',
    cast: ['周深', '黄渤', '杨幂'],
  },
  {
    id: 9,
    title: '长安十二时辰之终极对决',
    subtitle: 'The Longest Day in Chang\'an: Final',
    year: 2026,
    category: 'dianshiju',
    rating: 9.3,
    duration: '48集',
    description: '故事延续《长安十二时辰》的宏大叙事，张小敬与李必再度联手，揭开隐藏在繁华长安城下的惊天阴谋。每集高潮迭起，令人欲罢不能。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20tv%20series%20poster%20set%20in%20ancient%20Tang%20dynasty%20Changan%20city%2C%20warriors%20in%20traditional%20armor%2C%20grand%20palace%20architecture%2C%20epic%20scale%2C%20warm%20golden%20lighting%2C%20cinematic&width=800&height=1120&seq=movie-009&orientation=portrait',
    tags: ['古装', '悬疑', '史诗'],
    isNew: true,
    isHot: true,
    isRecommended: true,
    region: '中国大陆',
    director: '曹盾',
    cast: ['雷佳音', '易烊千玺', '周一围'],
  },
  {
    id: 10,
    title: '战火兄弟连',
    subtitle: 'Band of Brothers: China',
    year: 2026,
    category: 'zhanzheng',
    rating: 9.0,
    duration: '145分钟',
    description: '抗美援朝战场上，一支普通连队的英勇故事。面对极寒天气和强大敌人，他们用血肉之躯筑起了钢铁长城。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20war%20movie%20poster%20with%20soldiers%20in%20winter%20battlefield%2C%20snowy%20mountain%20landscape%2C%20determined%20expressions%2C%20smoke%20and%20explosions%20in%20distance%2C%20epic%20cinematic%20style%2C%20desaturated%20cold%20tones&width=800&height=1120&seq=movie-010&orientation=portrait',
    tags: ['战争', '历史', '爱国'],
    isNew: false,
    isHot: true,
    isRecommended: true,
    region: '中国大陆',
    director: '陈凯歌',
    cast: ['吴京', '段奕宏', '张涵予'],
  },
  {
    id: 11,
    title: '地球脉动：中国篇',
    subtitle: 'Planet Earth: China',
    year: 2026,
    category: 'jilupian',
    rating: 9.6,
    duration: '6集',
    description: '跨越中国广袤大地的自然纪录片。从青藏高原到南海诸岛，从东北雪原到云南雨林，展现中国最震撼的自然风光和珍稀野生动物。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20nature%20documentary%20movie%20poster%20with%20snow%20leopard%20on%20Himalayan%20mountain%20peak%2C%20stunning%20landscape%2C%20golden%20sunrise%20lighting%2C%20majestic%20atmosphere%2C%20ultra%20detailed%20wildlife%20photography&width=800&height=1120&seq=movie-011&orientation=portrait',
    tags: ['自然', '纪录片', '震撼'],
    isNew: false,
    isHot: false,
    isRecommended: true,
    region: '中国大陆',
    director: '陆川',
    cast: ['旁白：陈道明'],
  },
  {
    id: 12,
    title: '欢乐喜剧人：巅峰之战',
    subtitle: 'Top Comedian: Final Battle',
    year: 2026,
    category: 'zongyi',
    rating: 8.4,
    duration: '12期',
    description: '国内顶尖喜剧人的终极对决。沈腾、贾玲、岳云鹏等喜剧大咖同台竞技，爆笑不断，精彩纷呈。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20comedy%20poster%20with%20comedians%20on%20stage%20under%20spotlights%2C%20colorful%20confetti%2C%20laughing%20expressions%2C%20bright%20stage%20lighting%2C%20festive%20atmosphere%2C%20entertainment%20show%20style&width=800&height=1120&seq=movie-012&orientation=portrait',
    tags: ['综艺', '搞笑', '竞技'],
    isNew: true,
    isHot: true,
    isRecommended: false,
    region: '中国大陆',
    director: '东方卫视',
    cast: ['沈腾', '贾玲', '岳云鹏'],
  },
  {
    id: 13,
    title: '卧虎藏龙：剑影',
    subtitle: 'Crouching Tiger: Shadow Sword',
    year: 2026,
    category: 'dongzuo',
    rating: 8.8,
    duration: '132分钟',
    description: '江湖上失传已久的绝世宝剑重现人间，引来了各方势力的争夺。李慕白的传人踏上了守护宝剑的征途。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20wuxia%20movie%20poster%20with%20female%20warrior%20flying%20through%20bamboo%20forest%2C%20flowing%20silk%20robes%2C%20moonlight%2C%20ethereal%20mist%2C%20elegant%20martial%20arts%20pose%2C%20traditional%20Chinese%20ink%20painting%20style&width=800&height=1120&seq=movie-013&orientation=portrait',
    tags: ['武侠', '动作', '古装'],
    isNew: false,
    isHot: false,
    isRecommended: true,
    region: '中国台湾',
    director: '李安',
    cast: ['杨紫琼', '甄子丹', '刘亦菲'],
  },
  {
    id: 14,
    title: '逆流大叔',
    subtitle: 'Men on the Dragon',
    year: 2025,
    category: 'xiju',
    rating: 8.1,
    duration: '108分钟',
    description: '四个中年大叔在职场和生活中处处碰壁，决定一起参加龙舟比赛来证明自己。笑中带泪的温情故事。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20drama%20movie%20poster%20with%20four%20middle-aged%20men%20rowing%20dragon%20boat%20on%20river%2C%20determined%20expressions%2C%20sunset%20lighting%2C%20urban%20cityscape%20background%2C%20warm%20golden%20tones&width=800&height=1120&seq=movie-014&orientation=portrait',
    tags: ['喜剧', '励志', '温情'],
    isNew: false,
    isHot: false,
    isRecommended: false,
    region: '中国香港',
    director: '陈咏燊',
    cast: ['吴镇宇', '黄德斌', '潘灿良'],
  },
  {
    id: 15,
    title: '末日崩塌：天火',
    subtitle: 'San Andreas: Sky Fire',
    year: 2026,
    category: 'kehuan',
    rating: 8.2,
    duration: '138分钟',
    description: '一颗巨型陨石正向地球袭来，人类面临灭顶之灾。全球科学家联手展开"天火计划"，在24小时内完成不可能的任务。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20disaster%20sci-fi%20movie%20poster%20with%20giant%20meteor%20approaching%20earth%2C%20city%20skyline%20in%20danger%2C%20dramatic%20orange%20sky%2C%20people%20running%2C%20epic%20scale%2C%20cinematic%20intensity&width=800&height=1120&seq=movie-015&orientation=portrait',
    tags: ['灾难', '科幻', '特效'],
    isNew: true,
    isHot: false,
    isRecommended: true,
    region: '中国大陆',
    director: '吴京',
    cast: ['吴京', '刘德华', '李雪健'],
  },
  {
    id: 16,
    title: '我们的四十年',
    subtitle: 'Our Forty Years',
    year: 2026,
    category: 'dianshiju',
    rating: 9.2,
    duration: '40集',
    description: '讲述了改革开放四十年来，一户普通中国人家的命运变迁。从农村到城市，从贫穷到富裕，折射出伟大时代的波澜壮阔。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20tv%20series%20poster%20showing%20Chinese%20family%20through%20decades%2C%20changing%20fashion%20and%20background%2C%20nostalgic%20warm%20tones%2C%20emotional%20family%20portrait%2C%20golden%20lighting&width=800&height=1120&seq=movie-016&orientation=portrait',
    tags: ['年代', '家庭', '温情'],
    isNew: true,
    isHot: true,
    isRecommended: true,
    region: '中国大陆',
    director: '孔笙',
    cast: ['胡歌', '刘涛', '王凯'],
  },
];

export const getMoviesByCategory = (categorySlug: string): Movie[] => {
  return movies.filter((m) => m.category === categorySlug);
};

export const getHotMovies = (): Movie[] => {
  return movies.filter((m) => m.isHot).slice(0, 8);
};

export const getNewMovies = (): Movie[] => {
  return movies.filter((m) => m.isNew).slice(0, 8);
};

export const getRecommendedMovies = (): Movie[] => {
  return movies.filter((m) => m.isRecommended).slice(0, 8);
};

export const getMovieById = (id: number): Movie | undefined => {
  return movies.find((m) => m.id === id);
};